import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, ArrowLeft, Home } from 'lucide-react';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary-50">
      <div className="max-w-md w-full text-center">
        <div className="bg-white rounded-lg shadow-lg p-8">
          {/* Icône */}
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center">
              <Shield className="h-10 w-10 text-red-600" />
            </div>
          </div>

          {/* Titre */}
          <h1 className="text-2xl font-bold text-secondary-900 mb-4">
            Accès non autorisé
          </h1>

          {/* Message */}
          <p className="text-secondary-600 mb-8">
            Vous n'avez pas les permissions nécessaires pour accéder à cette page.
            Veuillez contacter votre administrateur si vous pensez qu'il s'agit d'une erreur.
          </p>

          {/* Actions */}
          <div className="space-y-3">
            <button
              onClick={() => navigate(-1)}
              className="btn btn-secondary w-full flex items-center justify-center"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Retour
            </button>
            
            <button
              onClick={() => navigate('/')}
              className="btn btn-primary w-full flex items-center justify-center"
            >
              <Home className="h-4 w-4 mr-2" />
              Accueil
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
